import React, { useState } from 'react'
import * as R from 'ramda'
import { useHistory } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import TwoFactorLoginPage from '.'
import useAxios from 'hooks/useAxios'
import auth from 'auth'
import { signedInLogCallBack } from 'pages/Login/utils'
import { completeOAuthInOpenerOrNavigate } from 'libs/oauthIframeBridge'

export default function Page({ location }) {
  const history = useHistory()
  const { fetch, error, loading } = useAxios({
    method: 'post',
    url: '/login/2fa/verify/',
    skip: true,
    headers: {
      Authorization: `JWT ${R.prop('token', location.state)}`,
    },
  })
  const [otp, setOtp] = useState('')

  function handleVerifyOtp() {
    fetch({
      data: {
        otp,
      },
    })
      .then((response) => {
        // @ts-ignore
        auth.setToken(response.data.token)

        const urlParams = new URLSearchParams(window.location.search)
        const loginMethod =
          urlParams.get('login_method') || urlParams.get('logged_in_method') || '2fa'
        completeOAuthInOpenerOrNavigate(history, {
          pathname: R.path(['state', 'pathname'], location) || '/',
          search: '',
          state: signedInLogCallBack(loginMethod),
          token: response.data.token,
        })
      })
      .catch((error) => {
        if (error?.response?.status !== 400) {
          Sentry.captureException(error)
        }
      })
  }

  const errorMessage = error !== null ? 'Two-factor authentication failed.' : null

  return (
    <TwoFactorLoginPage
      otp={otp}
      onOtpChange={setOtp}
      errorMessage={errorMessage}
      verifyOtp={handleVerifyOtp}
      loading={loading}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/TwoFactorLogin/container.js